//入口页
const main = r =>
  require.ensure([], () => r(require("@/view/index.vue")), "main");
//车险入口
// 车生活 路由 开始-------------------------------------------
//  核保
const Details = r =>
  require.ensure([], () => r(require("@/view/carlife/details.vue")), "Details");
const Surequote = r =>
  require.ensure(
    [],
    () => r(require("@/view/carlife/surequote.vue")),
    "Surequote"
  );
const cshPay = r =>
  require.ensure([], () => r(require("@/view/carlife/pay.vue")), "Pay");
// 车险信息录入
const Carmessage = r =>
  require.ensure(
    [],
    () => r(require("@/view/carlife/carMessage.vue")),
    "Carmessage"
  );
// 车险比价
const Comparison = r =>
  require.ensure(
    [],
    () => r(require("@/view/carlife/comparison.vue")),
    "Comparison"
  );
//定制方案
const Customsolution = r =>
  require.ensure(
    [],
    () => r(require("@/view/carlife/customSolution.vue")),
    "Customsolution"
  );
//车险订单
const Orderlist = r =>
require.ensure(
  [],
  () => r(require("@/view/carlife/orderList.vue")),
  "Orderlist"
);
//Test
const Test = r =>
  require.ensure([], () => r(require("@/view/carlife/test.vue")), "Test");

//第三方跳转
const Thirdparty = r =>
  require.ensure(
    [],
    () => r(require("@/view/carlife/thirdparty.vue")),
    "Thirdparty"
  );

  //平安第三方跳转
const PayPA = r =>
  require.ensure([], () => r(require("@/view/carlife/paypa.vue")), "PayPA");

  //支付提示
const PayTips = r =>
  require.ensure([], () => r(require("@/view/carlife/payTips.vue")), "PayTips");

  //imageView
const imageView = r =>
  require.ensure(
    [],
    () => r(require("@/view/carlife/imageView.vue")),
    "imageView"
  );
// 车生活 路由 结束-------------------------------------------

//路由
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/main",
      component: main,
      name: "入口页",
      children: [
        // 车生活 路由 开始-------------------------------------------
        {
          path: "/surequote",
          name: "surequote",
          component: Surequote,
          meta: {
            keepAlive: true,
            title: "核保"
          }
        },
        {
          path: "/details",
          name: "details",
          component: Details,
          meta: {
            keepAlive: true,
            title: "详情"
          }
        },
        {
          path: "/pay",
          name: "pay",
          component: cshPay,
          meta: {
            keepAlive: true,
            title: "支付页"
          }
        },

        {
          path: "/comparison",
          name: "comparison",
          component: Comparison,
          meta: {
            keepAlive: true,
            title: "车险比价"
          }
        },
        {
          path: "/thirdparty",
          name: "thirdparty",
          component: Thirdparty,
          meta: {
            keepAlive: true,
            title: "第三方平台"
          }
        },
        {
          path: "/paypa",
          name: "paypa",
          component: PayPA,
          meta: {
            keepAlive: true,
            title: "平安第三方平台"
          }
        },
        {
          path: "/carmessage",
          name: "carmessage",
          component: Carmessage,
          meta: {
            keepAlive: true,
            title: "车险信息录入"
          }
        },
        {
          path: "/customsolution",
          name: "customsolution",
          component: Customsolution,
          meta: {
            keepAlive: true,
            title: "定制方案"
          }
        },
        {
          path: "/orderlist",
          name: "orderlist",
          component: Orderlist,
          meta: {
            keepAlive: true,
            title: "车险订单"
          }
        },
        {
          path: "/imageView",
          name: "imageView",
          component: imageView,
          meta: {
            keepAlive: true,
            title: "保险平台隐私政策"
          }
        },
        {
          path: "/payTips",
          name: "payTips",
          component: PayTips,
          meta: {
            keepAlive: true,
            title: "扫码支付"
          }
        },
        {
          path: "/test",
          name: "test",
          component: Test,
          meta: {
            keepAlive: true,
            title: "test"
          }
        }
        // 车生活 路由 结束------------------------------------------
      ]
    },
    {
      path: "/404",
      name: "404",
      meta: {
        type: "404",
        title: ""
      },
      component: () => import("../view/other/404.vue") //404
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});
//捕捉router
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};



// WEBPACK FOOTER //
// ./src/router/index.js